export const getSupportedSkills = () => [
  {
    skillId: 'agile-methodology',
  },
  {
    skillId: 'agile-product-development',
  },
  {
    skillId: 'amazon-web-services',
  },
  {
    skillId: 'artificial-intelligence',
  },
  {
    skillId: 'artificial-intelligence-and-machine-learning-ai-ml',
  },
  {
    skillId: 'artificial-neural-network',
  },
  {
    skillId: 'business-intelligence',
  },
  {
    skillId: 'business-intelligence-software',
  },
  {
    skillId: 'cloud-applications',
  },
  {
    skillId: 'cloud-computing',
  },
  {
    skillId: 'cloud-infrastructure',
  },
  {
    skillId: 'cloud-management',
  },
  {
    skillId: 'cloud-security',
  },
  {
    skillId: 'collaboration',
  },
  {
    skillId: 'computer-security-incident-management',
  },
  {
    skillId: 'critical-thinking',
  },
  {
    skillId: 'cyber-operations',
  },
  {
    skillId: 'cyber-security-assessment',
  },
  {
    skillId: 'cybersecurity',
  },
  {
    skillId: 'deep-learning',
  },
  {
    skillId: 'digital-marketing',
  },
  {
    skillId: 'emotional-intelligence',
  },
  {
    skillId: 'entrepreneurship',
  },
  {
    skillId: 'generative-ai',
  },
  {
    skillId: 'google-cloud-platform',
  },
  {
    skillId: 'human-centered-design',
  },
  {
    skillId: 'incident-response',
  },
  {
    skillId: 'information-architecture',
  },
  {
    skillId: 'infrastructure-security',
  },
  {
    skillId: 'initiative-and-leadership',
  },
  {
    skillId: 'leadership-development',
  },
  {
    skillId: 'machine-learning',
  },
  {
    skillId: 'machine-learning-algorithms',
  },
  {
    skillId: 'machine-learning-methods',
  },
  {
    skillId: 'management',
  },
  {
    skillId: 'management-training-and-development',
  },
  {
    skillId: 'market-analysis',
  },
  {
    skillId: 'market-research',
  },
  {
    skillId: 'marketing-effectiveness',
  },
  {
    skillId: 'marketing-management',
  },
  {
    skillId: 'marketing-strategy-and-techniques',
  },
  {
    skillId: 'math-and-logic',
  },
  {
    skillId: 'microsoft-azure',
  },
  {
    skillId: 'negotiation',
  },
  {
    skillId: 'openai',
  },
  {
    skillId: 'power-bi',
  },
  {
    skillId: 'product-management',
  },
  {
    skillId: 'sales-development',
  },
  {
    skillId: 'sales-management',
  },
  {
    skillId: 'sales-process',
  },
  {
    skillId: 'sales-prospecting',
  },
  {
    skillId: 'scrum-software-development',
  },
  {
    skillId: 'security-engineering',
  },
  {
    skillId: 'security-testing',
  },
  {
    skillId: 'software-testing',
  },
  {
    skillId: 'tableau-software',
  },
  {
    skillId: 'teamwork',
  },
  {
    skillId: 'ui-ux-research',
  },
  {
    skillId: 'user-experience',
  },
  {
    skillId: 'user-interface-and-user-experience-ui-ux-design',
  },
  {
    skillId: 'user-interface-ui-design',
  },
  {
    skillId: 'user-research',
  },
  {
    skillId: 'wireframing',
  },
];
